import { RelevanceReq, RelevanceDef } from "../type/relevance-def";

export class RelevanceAdapter {
  static toInputDTO(req: RelevanceReq): any {
    return {
      is_past_look: true,
      outcome_node: req.outcome_node,
      ...(req.strat_node ? { strat_node: req.strat_node } : {}),
    };
  }

  static toOutputDTO(res: any): RelevanceDef {
    return res;
  }
}
